/*
 * Blog listing — pagination + category filtering without page reload.
 * Intercepts clicks on the pager links AND the category menu (tag filter),
 * fetches the target page, swaps in the new grid + pager, updates the active
 * category pill, and scrolls to the top of the grid (offset by the sticky
 * header height). Falls back to a normal navigation on any error.
 *
 * The category menu lives OUTSIDE the swapped region so its counts (computed
 * from the unfiltered blog) stay correct — the active pill is updated in JS.
 */
(function () {
  function headerOffset() {
    var raw = getComputedStyle(document.body).getPropertyValue('--header-height');
    var h = parseInt(raw, 10);
    return (isNaN(h) ? 0 : h) + 16; // small breathing gap below the sticky header
  }

  function scrollToRegion(region) {
    var top = region.getBoundingClientRect().top + window.scrollY - headerOffset();
    window.scrollTo({ top: top < 0 ? 0 : top, behavior: 'smooth' });
  }

  function loadPage(region, url, push) {
    region.classList.add('is-loading');
    fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.getElementById(region.id);
        if (!fresh) throw new Error('region not found');
        region.innerHTML = fresh.innerHTML;
        if (push) history.pushState({ blogRegion: region.id }, '', url);
        region.classList.remove('is-loading');
        scrollToRegion(region);
      })
      .catch(function () {
        // Something went wrong — let the browser handle it normally.
        window.location.href = url;
      });
  }

  // Mark the active pill matching the current URL (or "" for the base blog URL).
  function syncActiveCat(url) {
    var cats = document.querySelectorAll('[data-blog-cats]');
    for (var c = 0; c < cats.length; c++) {
      var links = cats[c].querySelectorAll('.blog-cat');
      for (var i = 0; i < links.length; i++) {
        var href = links[i].getAttribute('href');
        // Compare pathnames so query strings / origins don't break the match.
        var match = new URL(href, window.location.origin).pathname ===
          new URL(url, window.location.origin).pathname;
        links[i].classList.toggle('is-active', match);
        if (match) {
          links[i].setAttribute('aria-current', 'page');
        } else {
          links[i].removeAttribute('aria-current');
        }
      }
    }
  }

  function bind(region) {
    if (region.dataset.blogBound) return;
    region.dataset.blogBound = '1';
    region.addEventListener('click', function (e) {
      var link = e.target.closest('.blog-pager a[href]');
      if (!link || !region.contains(link)) return;
      e.preventDefault();
      loadPage(region, link.getAttribute('href'), true);
    });
  }

  // Category pills sit outside the region — bind them to swap the region too.
  function bindCats(nav) {
    if (nav.dataset.blogCatsBound) return;
    nav.dataset.blogCatsBound = '1';
    nav.addEventListener('click', function (e) {
      var link = e.target.closest('.blog-cat[href]');
      if (!link || !nav.contains(link)) return;
      var region = document.querySelector('[data-blog-region]');
      if (!region) return; // no region on the page → let the link navigate
      e.preventDefault();
      var url = link.getAttribute('href');
      syncActiveCat(url);
      loadPage(region, url, true);
    });
  }

  function init() {
    var regions = document.querySelectorAll('[data-blog-region]');
    for (var i = 0; i < regions.length; i++) bind(regions[i]);
    var cats = document.querySelectorAll('[data-blog-cats]');
    for (var j = 0; j < cats.length; j++) bindCats(cats[j]);
  }

  window.addEventListener('popstate', function () {
    syncActiveCat(window.location.href);
    var regions = document.querySelectorAll('[data-blog-region]');
    for (var i = 0; i < regions.length; i++) {
      loadPage(regions[i], window.location.href, false);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-bind in the Shopify theme editor when the section is re-rendered.
  document.addEventListener('shopify:section:load', init);
})();
